const STORAGE_KEY = 'seyai.deviceId';
const COOKIE_MAX_AGE_SECS = 60 * 60 * 24 * 365 * 5;

function readLocal(storage: Storage | null): string | null {
  if (!storage) return null;
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return null;
    if (raw.startsWith('{')) {
      const parsed = JSON.parse(raw) as { id?: string };
      return parsed.id ?? null;
    }
    return raw;
  } catch {
    return null;
  }
}

function readCookie(): string | null {
  if (typeof document === 'undefined') return null;
  try {
    const match = document.cookie.split('; ').find(c => c.startsWith(`${STORAGE_KEY}=`));
    if (!match) return null;
    const value = decodeURIComponent(match.slice(STORAGE_KEY.length + 1));
    return value || null;
  } catch {
    return null;
  }
}

function persist(id: string) {
  try { localStorage.setItem(STORAGE_KEY, id); } catch { /* noop */ }
  try { sessionStorage.setItem(STORAGE_KEY, id); } catch { /* noop */ }
  if (typeof document !== 'undefined') {
    try {
      document.cookie = `${STORAGE_KEY}=${encodeURIComponent(id)}; max-age=${COOKIE_MAX_AGE_SECS}; path=/; SameSite=Lax`;
    } catch { /* noop */ }
  }
}

function generate(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `dev-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

let cached: string | null = null;

export function ensureDeviceId(): string {
  if (cached) return cached;

  const existing =
    readLocal(typeof localStorage !== 'undefined' ? localStorage : null) ??
    readLocal(typeof sessionStorage !== 'undefined' ? sessionStorage : null) ??
    readCookie();

  const id = existing ?? generate();
  persist(id);
  cached = id;
  return id;
}

export function getDeviceId(): string {
  return ensureDeviceId();
}
